/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import Navbar from '@/components/Navbar';
import { BookCard } from '@/pages/Livros';
import { Loader2, BookOpen } from 'lucide-react';

/**
 * Admin-only preview of the public catalogue including books in every
 * status (except "hidden"), so the admin can see exactly what would go
 * live if the section were switched to Published.
 */
export default function AdminLivrosPreview() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.is_admin) { navigate('/home'); return; }
    (async () => {
      try {
        const { data } = await api.get('/admin/livros/preview/catalogue');
        setBooks(data);
      } finally { setLoading(false); }
    })();
  }, [user, navigate]);

  if (loading) return <div className="min-h-screen bg-background"><Navbar /><div className="flex items-center justify-center h-96"><Loader2 className="w-8 h-8 animate-spin text-ruby" /></div></div>;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Pré-visualizar Livros — Admin</title>
      </Helmet>
      <div className="min-h-screen bg-background">
        <Navbar />
        <main className="max-w-6xl mx-auto px-4 pt-24 pb-16">
          <div className="mb-6 rounded-md border border-amber-500/40 bg-amber-500/10 text-amber-300 px-4 py-2 text-sm">
            👁️ Pré-visualização do catálogo — mostra TODOS os estados exceto "Oculto". Não indexável e não acessível publicamente.
          </div>
          <div className="mb-8">
            <h1 className="text-4xl md:text-5xl font-bold text-foreground flex items-center gap-2"><BookOpen className="w-7 h-7 text-ruby" />Livros</h1>
            <p className="text-muted-foreground text-sm mt-2">Uma seleção curada.</p>
          </div>
          {books.length === 0 ? (
            <p className="text-muted-foreground text-center py-16">Ainda não há livros.</p>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6" data-testid="admin-preview-grid">
              {books.map(b => <BookCard key={b.id} book={b} adminBadge={b._admin_status} />)}
            </div>
          )}
        </main>
      </div>
    </>
  );
}
